import {NgModule} from '@angular/core';
import {UnsavedChangesNotifierService} from '@application/helper/unsaved-changes-notifier/unsaved-changes-notifier.service';
import {HttpProductionOrdersWeavingService} from '@infrastructure/http/production-order-weaving/http-production-orders-weaving.service';
import {PRODUCTION_ORDERS_WEAVING} from '@infrastructure/http/production-order-weaving/production-orders-weaving';
import {HttpProductionSchedulesService} from '@infrastructure/http/production-schedule/http-production-schedules.service';
import {PRODUCTION_SCHEDULES} from '@infrastructure/http/production-schedule/production-schedules';
import {REALTIME_PRODUCTION_ORDER_LITE} from '@infrastructure/signalr/production-order-lite/realtime-production-order-lite';
import {SignalrProductionOrderLiteService} from '@infrastructure/signalr/production-order-lite/signalr-production-order-lite.service';
import {TextileDataSharedModule} from '@presentation/pages/textile-data/textile-data-shared.module';
import {SharedModule} from '@shared/shared.module';
import {CanShowErrorForFormControlModule} from '@vdw/angular-component-library';
import {AddProductionOrderWeavingPageComponent} from './add/add-production-order-weaving-page.component';
import {ProductionOrderWeavingOverviewPageComponent} from './overview/production-order-weaving-overview-page.component';
import {productionOrderWeavingRouting} from './production-order-weaving.routing';
import {ProductionOrderWeavingSettingsComponent} from './settings/production-order-weaving-settings.component';

@NgModule({
  imports: [productionOrderWeavingRouting, TextileDataSharedModule, CanShowErrorForFormControlModule, SharedModule],
  providers: [
    UnsavedChangesNotifierService,
    {provide: PRODUCTION_ORDERS_WEAVING, useClass: HttpProductionOrdersWeavingService},
    {provide: PRODUCTION_SCHEDULES, useClass: HttpProductionSchedulesService},
    {provide: REALTIME_PRODUCTION_ORDER_LITE, useClass: SignalrProductionOrderLiteService}
  ],
  declarations: [ProductionOrderWeavingOverviewPageComponent, AddProductionOrderWeavingPageComponent, ProductionOrderWeavingSettingsComponent]
})
export class ProductionOrderWeavingModule {}
